<template>
  <div
    class="automacao-editor__canvas js-automacao-canvas"
    @dragover.prevent
    @drop="soltar"
  >
    <ul v-if="errosGerais.length" class="automacao-editor__avisos-gerais">
      <li v-for="(item, indice) in errosGerais" :key="indice">{{ item }}</li>
    </ul>
    <p class="automacao-editor__canvas-dica">
      Arraste e ligue os blocos. Scroll do mouse para zoom. Clique na linha e Delete, ou clique com o direito, para desligar. Na condição, a de cima é Sim e a de baixo é Não.
    </p>
    <div ref="drawflow" class="automacao-editor__drawflow js-automacao-drawflow"></div>
  </div>
</template>

<script>
export default {
  name: 'AutomacaoCanvas',
  props: {
    errosGerais: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  methods: {
    soltar(event) {
      this.$emit('drop-bloco', event)
    },
  },
}
</script>
